var render = function render(_c, _vm) {
  return _vm.$options.methods.toggleDisplay(_vm.props.toggle)
    ? _c("span", { class: _vm.props.slotClass }, [_vm._t("default")], 2)
    : _c("span", { class: _vm.props.slotClass }, [_vm._t("alternative")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }